import { componentStyle } from '@/styling/util/component-style.ts';

export const galleriaStyle = componentStyle({
    borderWidth: '0',
    thumbnailsContentBackground: '{ color.backgroundBluegray }',
    navButtonColor: '{ primary.500 }',
    navButtonHoverColor: '{ primary.600 }',
    navIconSize: '2rem',
});
